"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwLabel = _interopRequireDefault(require("../cwlabel/CwLabel"));

var _DayPicker = _interopRequireDefault(require("./DayPicker.scss"));

var _classnames = _interopRequireDefault(require("classnames"));
/**
 * Lays out the label for each day of the week as a single table row with 7 td elements
 */


var WeekDays = function WeekDays(props) {
  var days = props.daysOfTheWeek;
  var result = days.map(function (item) {
    return _react.default.createElement("td", {
      className: (0, _classnames.default)(_DayPicker.default.weekDays),
      key: item
    }, _react.default.createElement(_CwLabel.default, null, item));
  });
  return _react.default.createElement("tr", null, result);
};

WeekDays.propTypes = {
  /**
   * An array of localized days of the week
   */
  daysOfTheWeek: _propTypes.default.array
};
WeekDays.defaultProps = {
  daysOfTheWeek: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
};
var _default = WeekDays;
exports.default = _default;